import PackageTradeItem from '@/models/PackageTradeItem';
import PackageTradeItemService from '@/services/PackageTradeItemService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const usePackageTradeItemsStore = defineStore('package_trade_items', {
  state: () => ({}),

  getters: {
    models: () => useRepo(PackageTradeItem),
  },

  actions: {
    async create(projectId: Id, packageId: Id, form: ApiRequests['api.v1.package-trade-items.store']) {
      const [data, error] = await PackageTradeItemService.create(projectId, packageId, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async update(id: Id, form: ApiRequests['api.v1.package-trade-items.update']) {
      const [data, error] = await PackageTradeItemService.update(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async delete(id: Id) {
      const [data, error] = await PackageTradeItemService.delete(id);

      if(error) {
        throw error;
      }

      this.models.save(data.package_trade_item);
      this.models.save(data.sort_order);
      this.models.destroy(data.package_trade_item.id);

      return data;
    },

    async assignWbsCode(packageId: Id, form: ApiRequests['api.v1.package-trade-items.wbs-code']) {
      const [data, error] = await PackageTradeItemService.assignWbsCode(packageId, form);

      console.log(data);

      if(error) {
        throw error;
      }

      return data;
    },

    async updateForecastAmounts(id: Id, form: ApiRequests['api.v1.package-trade-items.forecast-amounts']) {
      const [data, error] = await PackageTradeItemService.updateForecastAmounts(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
